module.exports = __webpack_public_path__ + "static/media/mock-aero3.ccd69197.png";